export enum ValidDateFormatsEnum {
  MM_DD_YYYY = 'MM/dd/yyyy',
  YYYY_MM_DD = 'yyyy-MM-dd',
  DD_MM_YYYY = 'dd/MM/yyyy',
  YYYY_MM_DD_SLASH = 'yyyy/MM/dd',
  MMM_DD_YYYY = 'MMM dd, yyyy',
  MMMM_DD_YYYY = 'MMMM dd, yyyy',
  DD_MMMM_YYYY = 'dd MMMM yyyy',
  YYYY_MM_DD_HH_MM_SS = 'YYYY-MM-DD HH:mm:ss',
  ISO_8601 = "yyyy-MM-dd'T'HH:mm:ss.SSSxxx",
  DD_MM_YYYY_DASH = 'dd-MM-yyyy',
  ISO_DD_MM_YYYY_DASH = "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'",
  LLL_DD_YYYY = 'LLL dd, y',
}

export const validDateFormats: string[] = Object.values(ValidDateFormatsEnum);
